import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import { Provider } from 'react-redux'
import { QueryClientProvider } from '@tanstack/react-query'
import store from './store/configureStore'
import queryClient from './queryClient'

ReactDOM.render(
  <Provider store={store} >
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </Provider>,
  document.getElementById('root')
);
